module.exports = __webpack_public_path__ + "static/media/lightLeftGreenCircle.9a124372.svg";